import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { trackPageView, trackEvent } from '../../analytics/ga';

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;

    // General page view tracking
    trackPageView(path);


    // Specific tracking for /register
    if (location.pathname === '/register') {
      trackEvent('Visited Register Page', {
        category: 'Navigation',
        label: 'User visited /register',
      });
    }
  }, [location]);

  return null;
}
